import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmSimpleTextareaComponent } from './sm-simple-textarea.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { SmErrorModule } from '../sm-error/sm-error.module';

@NgModule({
  declarations: [SmSimpleTextareaComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AngularEditorModule,
    SmErrorModule
  ],
  exports: [SmSimpleTextareaComponent],
})
export class SmSimpleTextareaModule {}
